"function"!=typeof Object.values&&(Object.values=function(e){for(var t=Object.keys(e),n=t.length,r=new Array(n);n--;)r[n]=e[t[n]];return r});
